define 'controller/DirectOrderController', ['jquery', 'lib/kryptonite', 'lib/formdata', 'lib/inputmask'], ($) ->
  class DirectOrderController
  
    constructor: (@$el) ->
      $('#directOrder').off 'submit'
      $('#directOrder').off 'click'
      $('#directOrderForm').off 'change'
      
      @_initialize()
      @_search()
      @_clearSearch()
      @_changeQuantity()
      @_changeSize()
      @_changeColor()
      @_changeModel()
      @_submit()

    _initialize: ->
      allSelectHaveValue = true
      
      $('#directOrderForm select').each ->
        if $(this).val() == ''
          allSelectHaveValue = false
      
      if allSelectHaveValue
        $('#directOrderForm .direct-order__addtocart').prop('disabled', false)
      else
        $('#directOrderForm .direct-order__addtocart').prop('disabled', true)
        $('.direct-order__product__availibility').html('')
      
    _search: ->
      self = @
      $('#directOrder').on 'submit', '#directOrderSearch', (e) ->
        e.preventDefault()
        
        $.kryptonite
          url: $(@).attr('action')
          type: $(@).attr('method')
          data: $(@).serializeObject()
          complete: ->
            self._initialize()
            
    _clearSearch: ->
      $('#directOrder').on 'click', '.line-item__delete a', (e) ->
        e.preventDefault()
        $('#directOrder .direct-order__reference__text').show()
        $('#directOrder .direct-order__reference--selected').remove()
        $('#directOrder .line-item__delete').remove()
        $('#directOrder #reference-id').val('')
   
    _changeQuantity: ->
      self = @
      $('#directOrderForm').on 'change', '#directOrderQuantitySelect', (e) ->
        $el = $(@)
        self._initialize()
        
    _changeSize: ->
      self = @
      $('#directOrderForm').on 'change', '#directOrderVariationSelect', (e) ->
        value = $(e.target).find('option:selected').val()
        if value.length > 0
          $.kryptonite
            url: $('#directOrderForm').data('change-size')
            type: 'POST'
            data: $(@).serializeObject()
            complete: ->
              self._initialize()
        else
          self._initialize()
              
    _changeColor: ->
      self = @
      $('#directOrderForm').on 'change', '#directOrderColorSelect', (e) ->
        $.kryptonite
          url: $('#directOrderForm').data('change-color')
          type: 'POST'
          data: $(@).serializeObject()
          complete: ->
            self._initialize()
            
    _changeModel: ->
      self = @
      $('#directOrderForm').on 'change', '#directOrderPromoItemSelect', (e) ->
        $.kryptonite
          url: $('#directOrderForm').data('change-model')
          type: 'POST'
          data: $(@).serializeObject()
          complete: ->
            self._initialize()
            
    _submit: ->
      self = @
      $('#directOrderForm').on 'click', '.direct-order__addtocart', (e) ->
        e.preventDefault()

        $form = $(@).closest('form')
        url = $form.attr('action')
        
        if dataLayer?
          dataLayer.push( { 'event': 'basketDirectOrder', 'eventCategory': 'Suivi de conversion', 'eventAction': 'Clic', 'eventLabel': 'Suivi de clic - DIRECT ORDER' } )
          variationExternalKey = $form.find('#directOrderVariationSelect').val()
          if (variationExternalKey)
            if (variationExternalKey.length == 10)
              variationExternalKey = variationExternalKey.replace('_',  '00')
            else
              variationExternalKey = variationExternalKey.replace('_',  '0')
          dataLayer.push({ 'event': '_addToCart', 'eventCategory': 'SmartFocus', 'eventAction': variationExternalKey, 'eventLabel': 'add to basket' })
        $.kryptonite
          url: url
          type: 'POST'
          data: $form.serializeObject()
          complete: ->
            self._initialize()
            self._triggerGiftCheck()

    _triggerGiftCheck: ->
      giftCheckEvent = new Event('gift-check',bubbles: true)
      document.dispatchEvent(giftCheckEvent)

    destroy: ->
      @$el.off()